// extracted by mini-css-extract-plugin
export default {"textInput":"Search_textInput__m-Y0L"};